import React, { Component } from 'react'
import './RadioField.scss'

export class RadioField extends Component {
  static defaultProps = {
    meta: {},
    input: {
      value: '',
      onChange: () => null,
    },
    options: [],
  }

  render() {
    const {
      label,
      options,
      className,
      meta: { touched, error },
    } = this.props
    const { value, onChange } = this.props.input
    return (
      <div className={`${className ? className : ''}`}>
        {label && <label>{label}</label>}
        <div className={`radio-field`}>
          {options.map((option) => (
            <label key={option.id}>
              <input
                type="radio"
                onChange={() => onChange(option)}
                checked={option.checked || option.id === value.id}
              />
              <span>{option.name}</span>
            </label>
          ))}
        </div>
        {touched && error && <span style={{ color: 'red' }}>{error}</span>}
      </div>
    )
  }
}
